import { render, staticRenderFns } from "./NewWorkspace.vue?vue&type=template&id=65b2b62a&"
import script from "./NewWorkspace.vue?vue&type=script&lang=js&"
export * from "./NewWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./NewWorkspace.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports